import { deleteItinerary, loadItineraries } from 'actions/accountActions';
import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Itinerary } from 'services/dataService';
import styled from 'styled-components';
import SelectedPlansOptionsSection from './components/plans_section/SelectedPlansOptionsSection';
import SmallComponent from './components/SmallComponent';

const PageContainer = styled.div`
  width: ${props => (props.editMode ? '100%' : '118.8rem')};
`;


function TripsPage() {
  const dispatch = useDispatch();

  const user = useSelector((state: any) => state.user.current);

  const [itineraries, setItineraries] = useState([] as Itinerary[]);
  const [selectedItinerary, setSelectedItinerary] = useState({} as Itinerary);
  
  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData() {
    let initialItineraries: any = await dispatch(loadItineraries());
    if (!initialItineraries) { return;}
    
    setItineraries(initialItineraries);
    setSelectedItinerary(itineraries[0]);

    const userId = user?.id;

    if (!userId) return;
  }

  function selectItinerary(id) {
    for (let key of Object.keys(itineraries)) {
      const itinerary = itineraries[key];

      if (itinerary.id === id) {
        setSelectedItinerary(itinerary);
        break;
      }
    }
  }

  async function deleteActiveItinerary(id: string) {
    console.log("deleting", id);
    await dispatch(deleteItinerary(id));
    await initData();
  }

  function render() {
    return (
      <PageContainer>
        <AppPageHeader title="My saved trips" />

        <PageRow>
          <SelectedPlansOptionsSection itineraries={itineraries} activeItinerary={selectedItinerary ? selectedItinerary : {} as Itinerary} onSelect={selectItinerary} onDelete={deleteActiveItinerary} />
          <SmallComponent trips={selectedItinerary && selectedItinerary.trips ? selectedItinerary.trips : []} title="Your stops"/>
        </PageRow>
      </PageContainer>
    );
  }

  return render();
}

export default TripsPage;
